/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogInCommand
 */
export interface LogInCommand {
    /**
     * 
     * @type {string}
     * @memberof LogInCommand
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof LogInCommand
     */
    password: string;
}

/**
 * Check if a given object implements the LogInCommand interface.
 */
export function instanceOfLogInCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function LogInCommandFromJSON(json: any): LogInCommand {
    return LogInCommandFromJSONTyped(json, false);
}

export function LogInCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogInCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
    };
}

export function LogInCommandToJSON(value?: LogInCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
    };
}

